import { useMemo } from 'react';

import { ICD9Procedure } from '@dreryk/egabinet-icd-dictionary-frontend-api';

import { TranslatableText } from '@dreryk/react-common';
import { MarginPosition, StaticDataConfiguration, Table, ValidationErrorNotification } from '@dreryk/react-components';

import { useIcd9ProceduresTableConfiguration } from './Icd9ProcedureTable.hooks';
import { StyledIcd9ProcedureTable } from './Icd9ProcedureTable.styled';

type Icd9ProcedureTableProps = {
   readonly procedures: ICD9Procedure[];
   readonly removeItem?: (item: ICD9Procedure) => void;
   readonly error?: TranslatableText;
};

export const Icd9ProcedureTable = (props: Icd9ProcedureTableProps): JSX.Element | null => {
   const dataConfiguration = useMemo<StaticDataConfiguration<ICD9Procedure>>(() => ({ data: props.procedures }), [
      props.procedures,
   ]);
   const columns = useIcd9ProceduresTableConfiguration(props.removeItem);

   if (!dataConfiguration.data.length) {
      return null;
   }

   return (
      <StyledIcd9ProcedureTable>
         <Table<ICD9Procedure>
            compact
            columns={columns}
            dataConfiguration={dataConfiguration}
            keyExtractor={'code'}
            pageSize={5}
            numberOfPagesToBuffer={5}
            enableStaticSorting
            testId={'selectorResults'}
         />
         {props.error ? (
            <ValidationErrorNotification testId={'error'} label={props.error} margin={MarginPosition.TOP} />
         ) : null}
      </StyledIcd9ProcedureTable>
   );
};
